import actions from './actions';
import getters from './getters'
import mutations from './mutations';


const getDefaultState = () => ({
  deliveryTypes : [],
  deliveryTypes_outdated : true,
  locations : [],
  locations_outdated : true,
  paymentMethods : [],
  paymentMethods_outdated : true,
  paymentTypeCategories : [],
  paymentTypeCategories_outdated : true,
  companyRoles : [],
  companyRoles_outDated : true,
  customerClasses : [],
  customerClasses_outdated : true,
  customerTags : [],
  // customerTags_outdated : true,
  currencies : [],
  currencies_outdated : true,
  languages : [],
  languages_outdated : true,
  customerCustomFieldDefinition : [],
  customerCustomFieldDefinition_outdated : true,
  deliveryScheduleExceptions : [],
  deliveryScheduleExceptions_outdated:true,
  purchaseOrderLinesCustomFieldsDefinition : [],
  purchaseOrderLinesCustomFieldsDefinitionInitialized : false,
  gl_accounts : [],
  gl_accounts_outdated:true, // -- TO INVALIDATE WHEN Switching company
  taxes : [],
  taxes_outdated:true, // -- TO INVALIDATE WHEN Switching company
  credit_note_types : [],
  credit_note_types_outdated : true, // -- TO INVALIDATE WHEN Switching company
  rebate_types : [],
  rebate_types_outdated : true, // -- TO INVALIDATE WHEN Switching company
  territories : [],
  territories_outdated : true,
  countries : [],
  countries_outdated : true,
  cmsConfiguration : null,
  multiAgencyConfiguration: null,
  agencyFeeProductInfo : null,
  emailCustomContentData : [],
  emailCustomContentOutdated : true, // -- TO INVALIDATE WHEN Switching company
  blogTypes : [],
  blogTypesOutdated : true,
  inventories: [],
  inventoriesOutdated: true, // -- TO INVALIDATE WHEN Switching company
  portausCompanies : [],
  portausCompaniesOutdated : true,
});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
